// const openFormBtn = document.querySelector('.openFormBtn');
// const cancelBtn = document.getElementById('cancelBtn');
// const slides = document.querySelector('.slides');
// const slideCount = document.querySelectorAll('.slide');
// const prevButton = document.querySelector('.prev');
// const nextButton = document.querySelector('.next');
// const tabs = document.querySelectorAll('button[id^="tab"]');
// const contents = document.querySelectorAll('div[id^="content"]');
// const form = document.getElementById("contact-form");

// cancel button function
// console.log('beginning of function')
// if (openFormBtn) {
//     openFormBtn?.addEventListener('click', function () {
//         window.location.href = 'contact.html';
//     });
// }
window.cancelBtn = document.getElementById('cancelBtn');

if (window.cancelBtn) {
    window.cancelBtn?.addEventListener('click', () => {
        window.history.back();
        console.log('Go back')
    });
    // console.log("cancel")
}
// cancel button function

// // slide function
// let currentIndex = 0;

// function updateSlider() {
//     slides.style.transform = `translateX(-${currentIndex * 100}%)`;
// }

// function showSlide(index) {
//   slideCount.forEach((slide, i) => {
//     slide.classList.toggle('hidden', i !== index);
//   });
// }

// prevButton?.addEventListener('click', () => {
//     currentIndex = (currentIndex === 0) ? slideCount.length - 1 : currentIndex - 1;
//     showSlide(currentIndex);
// });

// nextButton?.addEventListener('click', () => {
//     currentIndex = (currentIndex === slideCount.length - 1) ? 0 : currentIndex + 1;
//     showSlide(currentIndex);
//     console.log(currentIndex)
// });

// showSlide(currentIndex);

// tabs.forEach(tab => {
//     tab.addEventListener('click', function () {
//         tabs.forEach(t => t.classList.remove('text-wine500', 'border-wine500'));
//         contents.forEach(content => content.classList.add('hidden'));

//         tab.classList.add('text-wine500', 'border-wine500');
//         document.getElementById(`content${tab.id.slice(-1)}`).classList.remove('hidden');
//     });
// });
// //end of slide function

// equipment description function
// function changeImage(imageSrc, title, description) {
//   document.getElementById('mainImage').src = imageSrc;
//   document.getElementById('productTitle').textContent = title;
//   document.getElementById('productDescription').innerHTML = '<p>' + description + '</p>';
// }

// document.querySelector('button').addEventListener('click', function() {
//   document.querySelector('.max-w-5xl').style.display = 'none';
// });
  //end of equipment description function

// // form fuction
// console.log('beginning of form function')
// const validateInput = (input, errorElement, validationFunction, errorMessage) => {
//   const isValid = validationFunction(input.value.trim());
//   if (errorElement) {
//     errorElement.textContent = isValid ? "" : errorMessage;
//   } else if (!isValid) {
//     input.setCustomValidity(errorMessage);
//   } else {
//     input.setCustomValidity("");
//   }
//   console.log(isValid, 'from validate input')
//   console.log(errorElement, 'from validate input error element')
//   console.log(errorMessage, 'from validate input error message')
//   return isValid;
// };

// const validationFunctions = {
//   firstName: {
//     validate: value => value.length >= 2,
//     errorMessage: "First name is less than 2 characters."
//   },
//   lastName: {
//     validate: value => value.length >= 2,
//     errorMessage: "Last name is less than 2 characters."
//   },
//   phoneNumber: {
//     validate: value => /^[0]{1}[0-9]{10}$/.test(value),
//     errorMessage: "Phone number must be 11 digits and start with 0."
//   },
//   email: {
//     validate: value => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
//     errorMessage: "Email must match pattern 'username@domain.com."
//   },
//   equipmentNeeded: {
//     validate: value => value.length >= 2,
//     errorMessage: "Please specify the equipment needed."
//   },
//   message: {
//     validate: value => value.length >= 2,
//     errorMessage: "Message is less than 2 characters."
//   },
//   daysNeeded: {
//     validate: value => value != 0,
//     errorMessage: "Please enter a valid number of days."
//   }
// };

// const inputs = [
//   { element: document.getElementById("firstname"), errorElement: document.getElementById("firstname-error"), validation: validationFunctions.firstName },
//   { element: document.getElementById("lastname"), errorElement: document.getElementById("lastname-error"), validation: validationFunctions.lastName },
//   { element: document.getElementById("phoneNumber"), errorElement: document.getElementById("phoneNumber-error"), validation: validationFunctions.phoneNumber },
//   { element: document.getElementById("email"), errorElement: document.getElementById("email-error"), validation: validationFunctions.email },
//   { element: document.getElementById("equipmentNeeded"), errorElement: document.getElementById("equipmentNeeded-error"), validation: validationFunctions.equipmentNeeded },
//   { element: document.getElementById("message"), errorElement: document.getElementById("message-error"), validation: validationFunctions.message },
//   { element: document.getElementById("daysNeeded"),  errorElement: document.getElementById("daysNeeded-error"), validation: validationFunctions.daysNeeded },
// ];

// inputs?.forEach(({ element, errorElement, validation }) => {
//   element?.addEventListener("input", () => {
//     const isValid = validateInput(element, errorElement, validation.validate, validation.errorMessage);
//     console.log(`Validating ${element.id}: ${isValid}`);
//     console.log(validation)
//   });
// });

// form?.addEventListener("submit", function (event) {
//   event.preventDefault();
//   let isValid = true;

//   inputs?.forEach(({ element, errorElement, validation }) => {
//     const inputIsValid = validateInput(element, errorElement, validation.validate);
//     console.log(`Submitting ${element.id}: ${inputIsValid}`);
//     if (!inputIsValid) {
//       isValid = false;
//     }
//   });

//   if (isValid) {
//     console.log("Form is valid. Submitting...");
//     form.reset();
//   } else {
//     console.log("Form is invalid. Fix errors and try again.");
//   }
// });
// //end of form fuction

// console.log('end of file')